import { render, staticRenderFns } from "./msInputMulti.vue?vue&type=template&id=62fa1e7c&scoped=true"
import script from "./msInputMulti.vue?vue&type=script&lang=js"
export * from "./msInputMulti.vue?vue&type=script&lang=js"
import style0 from "./msInputMulti.vue?vue&type=style&index=0&id=62fa1e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa1e7c",
  null
  
)

export default component.exports